module.exports = __webpack_public_path__ + "img/charging-station-hyper-fast-desktop.72af427a.webp";